import { ExitToApp, Login } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import {
    Button,
    Grid,
    styled,
    Divider,
    Tooltip,
    IconButton,
    Avatar,
    Menu,
    MenuItem,
    ListItemIcon,
    Box,
    Typography,
} from '@mui/material';
import React from 'react';
import SideBarNav from '../BasicComponents/SideBarNav';
import logo from '../../assets/airTeachr-New-White-Logo.png';
import { Link, Link as RouterNavLink, useHistory } from 'react-router-dom';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';

const drawerWidth = 240;
const SideDrawerRoot = styled('div', {
    shouldForwardProp: prop => prop !== 'open',
    name: 'SideDrawerRoot',
    slot: 'Root',
    overridesResolver: (props, styles) => [
        styles.root,
        props.open === true && styles.open,
    ],
})(({ theme }) => ({}));

const CloseIconTheme = styled(CloseIcon)(({ theme }) => ({
    margin: '14px 20px',
    color: theme.palette.white.main,
    '&:hover': {
        color: theme.palette.fifth.main,
    },
}));

const ImgLogo = styled('img')(({ theme }) => ({
    maxHeight: '60px',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
        width: '100%',
        height: '60px',
        padding: '5px',
        margin: '5px 8px 10px 8px',
    },
    [theme.breakpoints.down('md')]: {
        height: '50px',
        width: '212px',
    },
    [theme.breakpoints.only('xs')]: {
        height: '35px',
        width: '148px',
    },
}));

const LinkStyle = styled(IconButton)(({ theme }) => ({
    color: '#FFFEFE',
    textDecoration: 'none',
    fontSize: '1.2em',
    display: 'inline-block',
    width: 220,
    padding: '10px 20px',
    margin: '0px 10px 0px 0px',
    borderRadius: '0px 30px 30px 0px',
    textAlign: 'left',
    verticalAlign: 'middle',
    '&:hover': {
        color: '#4632DA',
        textDecoration: 'none',
        background: '#FFFEFE',
    },
}));

const SideDrawer = props => {
    const history = useHistory();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <SideDrawerRoot
                open={props.show}
                data-cy="nav-bar-side"
                sx={{
                    width: `${drawerWidth}px`,
                    background:
                        'linear-gradient(130deg, #4632DA 0%, #06D9FA 90%)',
                    color: '#FFFEFE',
                    paddingTop: '0',
                    zIndex: 1,
                }}
            >
                {/*<CloseIconTheme fontSize="large" onClick={props.handleClose} />*/}
                {props.isAuthenticated && (
                    <Grid
                        data-cy="menu-drawer"
                        container
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                    >
                        <Link tag={RouterNavLink} to="/" exact>
                            <ImgLogo src={logo} alt="airTeachr logo" />
                        </Link>
                        <br />
                        {props.profileExists > 0 ? (
                            <>
                                <SideBarNav
                                    size="1.2em"
                                    link="/home"
                                    linkname="Home"
                                />

                                {props.profileLoaded === 'succeeded' &&
                                    !props.schoolNoPermission && (
                                        <div>
                                            <SideBarNav
                                                size="1.2em"
                                                link="/history"
                                                linkname="History"
                                            />
                                            <SideBarNav
                                                size="1.2em"
                                                link="/action"
                                                linkname="Actions"
                                            />
                                        </div>
                                    )}

                                {props.profile.type === 'Teacher' && (
                                    <>
                                        <SideBarNav
                                            size="1.2em"
                                            link="/teacher-availability"
                                            linkname="Availability"
                                        />
                                        <SideBarNav
                                            size="1.2em"
                                            link="/jobs"
                                            linkname="Jobs"
                                        />
                                    </>
                                )}
                                {props.profile.type === 'School' &&
                                    props.schoolAdmin && (
                                        <>
                                            <SideBarNav
                                                size="1.2em"
                                                link="/book-teacher"
                                                linkname="Book Teacher"
                                            />
                                            <SideBarNav
                                                size="1.2em"
                                                link="/casual-relief-teacher-list"
                                                linkname="Saved Teachers"
                                            />
                                            <SideBarNav
                                                size="1.2em"
                                                link="/jobs"
                                                linkname="School Jobs"
                                            />
                                        </>
                                    )}
                                {/*<SideBarNav
                                size="1.2em"
                                link="/profile/userInfo"
                                linkname="My Profile"
                            />*/}
                                <SideBarNav
                                    size="1.2em"
                                    link="/notifications"
                                    linkname="Notification"
                                    // icon={<NotificationsRoundedIcon />}
                                />
                            </>
                        ) : (
                            <>
                                <SideBarNav
                                    size="1.2em"
                                    link="/home"
                                    linkname="Create Profile"
                                />
                                <LinkStyle
                                    onClick={() =>
                                        props.logout({
                                            returnTo: window.location.origin,
                                        })
                                    }
                                >
                                    Logout
                                </LinkStyle>
                            </>
                        )}
                        <br />
                        <Divider
                            sx={{
                                width: '100%',
                                borderColor: 'rgba(255, 255, 255, 0.52)',
                                display: 'none',
                            }}
                        />

                        <Button
                            onClick={() =>
                                props.logout({
                                    returnTo: window.location.origin,
                                })
                            }
                            variant="contained"
                            color="primary"
                            startIcon={<ExitToApp />}
                            size="large"
                            sx={{
                                margin: '14px 20px',
                                width: '80%',
                                display: 'none',
                            }}
                        >
                            Log Out
                        </Button>

                        {props.profileExists > 0 && (
                            <>
                                {props.profileLoaded === 'succeeded' && (
                                    <React.Fragment>
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                justifyContent: 'center',
                                                position: 'absolute',
                                                bottom: 25,
                                            }}
                                        >
                                            <Tooltip title="Account settings">
                                                <IconButton
                                                    onClick={handleClick}
                                                    size="small"
                                                    aria-controls={
                                                        open
                                                            ? 'account-menu'
                                                            : undefined
                                                    }
                                                    aria-haspopup="true"
                                                    aria-expanded={
                                                        open
                                                            ? 'true'
                                                            : undefined
                                                    }
                                                    sx={{
                                                        background:
                                                            'rgba(255, 255, 255,0.12)',

                                                        '&:hover': {
                                                            background:
                                                                '#4632DA',
                                                        },
                                                    }}
                                                >
                                                    <Avatar
                                                        sx={{
                                                            width: 82,
                                                            height: 82,
                                                        }}
                                                        src={
                                                            props.profile
                                                                .profileImage
                                                        }
                                                        alt={
                                                            props.profile
                                                                .firstName
                                                        }
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                        <Menu
                                            anchorEl={anchorEl}
                                            id="account-menu"
                                            open={open}
                                            onClose={handleClose}
                                            onClick={handleClose}
                                            PaperProps={{
                                                elevation: 0,
                                                sx: {
                                                    overflow: 'visible',
                                                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                                    mt: -13.8,
                                                    width: 205,
                                                    '& .MuiAvatar-root': {
                                                        width: 32,
                                                        height: 32,
                                                        ml: -0.5,
                                                        mr: 1,
                                                    },

                                                    '&:before': {
                                                        content: '""',
                                                        display: 'block',
                                                        position: 'absolute',
                                                        bottom: 0,
                                                        right: '46%',
                                                        width: 10,
                                                        height: 10,
                                                        bgcolor:
                                                            'background.paper',
                                                        transform:
                                                            'translateY(50%) rotate(45deg)',
                                                        zIndex: 0,
                                                    },
                                                },
                                            }}
                                            transformOrigin={{
                                                horizontal: 'right',
                                                vertical: 'top',
                                            }}
                                            anchorOrigin={{
                                                horizontal: 'right',
                                                vertical: 'bottom',
                                            }}
                                        >
                                            <MenuItem
                                                onClick={() => {
                                                    history.push(
                                                        '/profile/userInfo'
                                                    );
                                                }}
                                            >
                                                <Avatar
                                                    src={
                                                        props.profile
                                                            .profileImage
                                                    }
                                                    alt={
                                                        props.profile.firstName
                                                    }
                                                />{' '}
                                                My Profile
                                            </MenuItem>
                                            <Divider />

                                            <MenuItem
                                                onClick={handleClose}
                                                sx={{ display: 'none' }}
                                            >
                                                <ListItemIcon>
                                                    <Settings fontSize="small" />
                                                </ListItemIcon>
                                                Settings
                                            </MenuItem>
                                            <MenuItem
                                                onClick={() =>
                                                    props.logout({
                                                        returnTo:
                                                            window.location
                                                                .origin,
                                                    })
                                                }
                                            >
                                                <ListItemIcon>
                                                    <Logout fontSize="small" />
                                                </ListItemIcon>
                                                Logout
                                            </MenuItem>
                                        </Menu>
                                    </React.Fragment>
                                )}
                            </>
                        )}
                    </Grid>
                )}

                {!props.isAuthenticated && (
                    <Grid
                        container
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                    >
                        {/* <SideBarNav size="1.2em" link="/about" linkname="About" />

                    <SideBarNav size="1.2em" link="/whyus" linkname="Why Us?" /> */}
                        {/*<SideBarNav
                            size="1.2em"
                            link="/signup"
                            linkname="Sign Up"
                        />*/}
                        <Button
                            onClick={() => (window.location.href = '/#signup')}
                            variant="contained"
                            color="primary"
                            startIcon={<LockOpenIcon />}
                            size="large"
                            sx={{
                                margin: '14px auto',
                                mt: 10,
                                width: '80%',
                                borderRadius: 50,
                                background: '#fff',
                                color: '#4632DA',
                                '&:hover': {
                                    background: '#4632DA',
                                    color: '#fff',
                                },
                            }}
                        >
                            Sign Up
                        </Button>
                        {/* <FakeLinkStyle
                            onClick={() =>
                                props.loginWithRedirect({
                                    scope: `${process.env.REACT_APP_scope} teacherProfile`,
                                    display: 'popup',
                                    screen_hint: 'signup',
                                })
                            }
                        >
                            Sign Up
                        </FakeLinkStyle> */}

                        <Button
                            onClick={() =>
                                props.loginWithRedirect({
                                    scope: `${process.env.REACT_APP_scope} teacherProfile`,
                                    display: 'popup',
                                })
                            }
                            variant="contained"
                            color="primary"
                            startIcon={<Login />}
                            size="large"
                            sx={{
                                margin: '14px auto',
                                width: '80%',
                                borderRadius: 50,
                                background: '#fff',
                                color: '#4632DA',
                                '&:hover': {
                                    background: '#4632DA',
                                    color: '#fff',
                                },
                            }}
                        >
                            Log in
                        </Button>
                        {/* <Grid item sx={{ padding: '14px 20px' }}>
                        <Button
                            onClick={() =>
                                loginWithRedirect({
                                    scope: 'teacherProfile',
                                    display: 'popup',
                                })
                            }
                            variant="contained"
                            color="primary"
                            startIcon={<Login />}
                            size="large"
                            sx={{ margin: '14px 20px' }}
                        >
                            Teacher Login
                        </Button>
                    </Grid>
                    <Grid item sx={{ padding: '14px 20px' }}>
                        <Button
                            onClick={() =>
                                loginWithRedirect({
                                    scope: 'schoolProfile',
                                    display: 'popup',
                                })
                            }
                            variant="contained"
                            color="secondary"
                            startIcon={<Login />}
                            size="large"
                            sx={{ margin: '14px 20px' }}
                        >
                            School Login
                        </Button>
                    </Grid> */}
                    </Grid>
                )}
            </SideDrawerRoot>
        </div>
    );
};

export default SideDrawer;
